import React from 'react';
import ReactDOM from 'react-dom/client';
import MyAccountCard from '../components/MyAccountCard';
import MyProjectsList from './MyProjectsList';
import { AuthenticationProvider } from '../context/AuthenticationContext';
import CreateProject from '../components/projects/CreateProject';

const $root: HTMLElement | null = document.getElementById(
	'timken-my-dashboard-my-projects',
);

if ($root) {
	ReactDOM.createRoot($root).render(
		<React.StrictMode>
			<AuthenticationProvider>
				<CreateProject />
				<MyAccountCard title="My Projects">
					<MyProjectsList />
				</MyAccountCard>
			</AuthenticationProvider>
		</React.StrictMode>,
	);
}
